import { DraftConfiguration, DraftState } from '@/types';
import { isDraftPlaceholderTextConfiguration } from '@/model/configuration/isDraftConfigurationType';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { getPrintAreaWidth } from '@/model/printArea/getPrintAreaSize';
import { updatePlaceholderSize } from './helper/updatePlaceholderSize';

export const setPlaceholderWidthAction =
  ({ cid }: DraftConfiguration, placeholderWidth: number) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    if (isDraftPlaceholderTextConfiguration(configuration)) {
      const { printArea, printType } = configuration;
      const width = Math.min(getPrintAreaWidth(printArea), printType.size.width, placeholderWidth);
      updatePlaceholderSize(configuration, width);
    }
  };
